var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoClipAdjunto(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "14px",
    viewBox: "0 0 15 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "paper-clip") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "C\\xEDrculo-del-Paciente",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 7,
    transform: "translate(-757.000000, -813.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nuevo-evento",
    transform: "translate(298.000000, 220.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "paper-clip",
    transform: "translate(459.000000, 593.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7286242,1.18342499 C12.0846213,-0.394776579 9.45641754,-0.394433343 7.8128281,1.18420507 L0.919478047,7.9474313 C-0.326977137,9.19918373 -0.303156078,11.2052764 0.972685832,12.428197 C2.22753722,13.6310226 4.23162293,13.6310226 5.48647432,12.428197 L11.728514,6.30401479 C12.5399884,5.50786205 12.5399884,4.21701186 11.728514,3.42085913 C10.9170396,2.62470639 9.60134754,2.62470639 8.78987315,3.42085913 L2.81921543,9.27875219 C2.61096404,9.49031071 2.61694316,9.82743139 2.83257303,10.0317507 C3.04292348,10.2310776 3.37638649,10.2310776 3.58673694,10.0317507 L9.55736286,4.17385767 C9.95328857,3.80172686 10.581732,3.81498827 10.9609925,4.20343842 C11.3288036,4.58015611 11.3288036,5.17429855 10.9609925,5.55101624 L4.71898462,11.6751673 C3.87573822,12.4907285 2.51825591,12.4811802 1.68699955,11.6538554 C0.864139406,10.834893 0.864139406,9.51939221 1.68699955,8.70042984 L8.58034961,1.93720362 C9.80823136,0.732068953 11.7993411,0.731725717 13.0276681,1.93639233 C14.2559951,3.14105895 14.256345,5.09460527 13.028495,6.29973993 L6.13511316,13.0629662 C5.90742964,13.2542737 5.88090525,13.5904583 6.07589445,13.8138429 C6.27088365,14.0372274 6.61353798,14.063251 6.8412215,13.8719435 C6.86246645,13.8540952 6.88224842,13.8346867 6.90044021,13.8138429 L13.7938221,7.05061665 C15.4271707,5.41278553 15.3980066,2.78593395 13.7286242,1.18342499 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoClipAdjunto);
export default __webpack_public_path__ + "static/media/ico-clip-adjunto.2bef8131f3989e2e6423e1f8d1ae1908.svg";
export { ForwardRef as ReactComponent };